var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPurchasing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9873 14.0831H14.2085C14.0158 14.0831 13.8596 14.2433 13.8596 14.4409V15.8148C13.8596 16.0124 14.0158 16.1726 14.2085 16.1726H17.9873C18.18 16.1726 18.3362 16.0124 18.3362 15.8148V14.4409C18.3362 14.2433 18.18 14.0831 17.9873 14.0831Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7788 3.62524H3.22121C2.5478 3.62524 2 4.18696 2 4.87748V18.373C2 19.0599 2.5478 19.6252 3.22121 19.6252H20.7788C21.4522 19.6252 22 19.0599 22 18.373V4.87748C22 4.18696 21.4522 3.62524 20.7788 3.62524ZM3.74459 5.41415H20.2554V8.24988H3.74459V5.41415ZM20.2554 17.8363H3.74459V11.2499H20.2554V17.8363Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPurchasing);
export default __webpack_public_path__ + "static/media/MenuPurchasing.27a70578334c1c2643f76cfd69f3e6e8.svg";
export { ForwardRef as ReactComponent };